module.exports = __webpack_public_path__ + "img/@news_list_bottom.94dc9e2b.jpg";